import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TableData } from '@shared/ui/tables';
import { map, switchMap } from 'rxjs/operators';
import { BaseListEvidenceService } from '../api/base-list-evidence.service';

import * as ListEvidenceActions from './list-evidence-store.actions';
import { ListEvidenceFacade } from './list-evidence-store.facade';
import { EvidenceBase, EvidenceOfficerBase } from '@shared/utils/evidence-management';

@Injectable()
export class ListEvidenceEffects {
  listEvidence$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ListEvidenceActions.listEvidence),
      switchMap((request) =>
        this.service.listEvidence(request.query).pipe(
          map(
            (response) =>
              new TableData(
                response.value.count,
                response.value.data.map(
                  (x) =>
                    new EvidenceBase(
                      x.uid,
                      x.recordedOn,
                      x.uploadedOn,
                      x.title,
                      x.incidentNumber,
                      x.incidentCadNumber,
                      x.type,
                      x.status,
                      new EvidenceOfficerBase(x.officer.uid, x.officer.firstName, x.officer.lastName, x.officer.emailAddress, x.officer.pictureFullPath),
                      x.thumbnailFullPath,
                      x.isLocked,
                      x.removeScheduledOn
                    )
                )
              )
          ),
          map((response) => ListEvidenceActions.listEvidenceSuccess({ evidence: response.data, count: response.count, query: request.query }))
        )
      )
    )
  );

  sharedWithMeEvidence$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ListEvidenceActions.sharedWithMeEvidence),
      switchMap((request) =>
        this.service.listEvidence(request.query).pipe(
          map(
            (response) =>
              new TableData(
                response.value.count,
                response.value.data.map(
                  (x) =>
                    new EvidenceBase(
                      x.uid,
                      x.recordedOn,
                      x.uploadedOn,
                      x.title,
                      x.incidentNumber,
                      x.incidentCadNumber,
                      x.type,
                      x.status,
                      new EvidenceOfficerBase(x.officer.uid, x.officer.firstName, x.officer.lastName, x.officer.emailAddress, x.officer.pictureFullPath),
                      x.thumbnailFullPath,
                      x.isLocked,
                      x.removeScheduledOn
                    )
                )
              )
          ),
          map((response) => ListEvidenceActions.sharedWithMeEvidenceSuccess({ evidenceSharedWithMe: response.data, sharedWithMeCount: response.count }))
        )
      )
    )
  );

  refreshEvidence$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ListEvidenceActions.refreshEvidence),
      switchMap(() => this.facade.getEvidenceQuery()),
      switchMap((query) =>
        this.service.listEvidence(query).pipe(
          map(
            (response) =>
              new TableData(
                response.value.count,
                response.value.data.map(
                  (x) =>
                    new EvidenceBase(
                      x.uid,
                      x.recordedOn,
                      x.uploadedOn,
                      x.title,
                      x.incidentNumber,
                      x.incidentCadNumber,
                      x.type,
                      x.status,
                      new EvidenceOfficerBase(x.officer.uid, x.officer.firstName, x.officer.lastName, x.officer.emailAddress, x.officer.pictureFullPath),
                      x.thumbnailFullPath,
                      x.isLocked,
                      x.removeScheduledOn
                    )
                )
              )
          ),
          map((response) => ListEvidenceActions.listEvidenceSuccess({ evidence: response.data, count: response.count, query: query }))
        )
      )
    )
  );

  constructor(private actions$: Actions, private service: BaseListEvidenceService, private facade: ListEvidenceFacade) {}
}
